import React from 'react'
import QuickStockInStandalone from '../Components/Admin/QuickStockInStandalone'

function QuickStockInPage() {
  return (
    <QuickStockInStandalone />
  )
}

export default QuickStockInPage
